import $script from 'scriptjs';
import Select from '../components/Select';

function newToggleHandler(e) {
  e.preventDefault();
  window.Shopify.CustomerAddress.toggleNewForm();
}

export default class StaticAddresses {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;

    const scripts = document.querySelector('[data-scripts]');
    this.updateProvinceSelects = this.updateProvinceSelects.bind(this);

    $script([scripts.dataset.shopifyCommonUrl],
      () => $script([scripts.dataset.customerAreaUrl],
        () => this._addAddressObservers()));
  }

  _addNewToggles() {
    this.newToggles = this.el.querySelectorAll('[data-customer-toggle-new-form]');

    for (let i = 0; i < this.newToggles.length; i++) {
      this.newToggles[i].addEventListener('click', newToggleHandler);
    }
  }

  _addToggles() {
    const toggleEls = this.el.querySelectorAll('[data-customer-toggle-form]');
    this.toggles = [];

    for (let i = 0; i < toggleEls.length; i++) {
      this.toggles[i] = { el: toggleEls[i] };
      this.toggles[i].handler = (e) => {
        e.preventDefault();
        window.Shopify.CustomerAddress.toggleForm(toggleEls[i].dataset.customerToggleForm);
      };
      toggleEls[i].addEventListener('click', this.toggles[i].handler);
    }
  }

  _addDeletes() {
    const deleteEls = this.el.querySelectorAll('[data-customer-delete-form]');
    this.deletes = [];

    for (let i = 0; i < deleteEls.length; i++) {
      this.deletes[i] = { el: deleteEls[i] };
      this.deletes[i].handler = (e) => {
        e.preventDefault();
        window.Shopify.CustomerAddress.destroy(
          deleteEls[i].dataset.customerDeleteForm,
          this.data.message_confirm_delete,
        );
      };
      deleteEls[i].addEventListener('click', this.deletes[i].handler);
    }
  }

  _getAddressIDs() {
    const addressDatas = this.el.querySelectorAll('[data-address-data]');
    const addressIDs = [];
    for (let i = 0; i < addressDatas.length; i++) {
      addressIDs.push(JSON.parse(addressDatas[i].innerHTML).address_id);
    }
    return addressIDs;
  }

  _initializeSelects() {
    const selects = this.el.querySelectorAll('select');
    this.selects = [];
    for (let i = 0; i < selects.length; i++) {
      this.selects.push(new Select({ el: selects[i] }));
    }
  }

  updateProvinceSelects() {
    setTimeout(() => this.selects.forEach((select) => {
      if (select.$el[0].id.indexOf('address-province') !== -1) {
        select.updateSelectText();
      }
    }), 100);
  }

  _addAddressObservers() {
    this.addressIDs = this._getAddressIDs();
    this.addressObservers = [];

    // initialize new address form
    this.addressObservers.push(new window.Shopify.CountryProvinceSelector(
      'address-country',
      'address-province',
      {
        hideElement: 'address-province-container',
      },
    ));

    // initialize edit address form(s)
    this.addressIDs.forEach((id) => {
      this.addressObservers.push(new window.Shopify.CountryProvinceSelector(
        `address-country-${id}`,
        `address-province-${id}`,
        {
          hideElement: `address-province-container-${id}`,
        },
      ));
    });

    this._addNewToggles();
    this._addToggles();
    this._addDeletes();
    this._initializeSelects();
    this.countries = this.el.querySelectorAll('[id^=address-country]');
    for (let i = 0; i < this.countries.length; i++) {
      this.countries[i].addEventListener('change', this.updateProvinceSelects);
    }
  }

  onSectionUnload() {
    for (let i = 0; i < this.countries.length; i++) {
      this.countries[i].removeEventListener('change', this.updateProvinceSelects);
    }

    for (let i = 0; i < this.newToggles.length; i++) {
      this.newToggles[i].removeEventListener('click', newToggleHandler);
    }

    this.toggles.forEach(toggle => toggle.el.removeEventListener('click', toggle.handler));
    this.deletes.forEach(del => del.el.removeEventListener('click', del.handler));
    this.selects.forEach(select => select.unload());
  }
}
